import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=5bc1b90e&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bc1b90e')) {
      api.createRecord('5bc1b90e', component.options)
    } else {
      api.reload('5bc1b90e', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=5bc1b90e&", function () {
      api.rerender('5bc1b90e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20tqdQE6k5XFX/JS/comp/pricelist.vue"
export default component.exports